import { Modal } from '@codametrix/ui-components';
import { Button, Flex, Box } from '@chakra-ui/react';
import React from 'react';
import { cmxDateTime } from '@codametrix/ui-common';

const AcceptableEula: React.FC<CMxCommonApp.EulaComponentProps> = props => {
  const {
    eula,
    context,
    optionalEulaAcceptancePayload,
    onEulaAccept,
    onEulaCancel
  } = props;

  const acceptEulaClick = () => {
    const datedEula: CMxAPI.Eula = {
      ...eula,
      acceptedDate: cmxDateTime.format(
        new Date(),
        cmxDateTime.FORMATS.DATE_TIME_EULA
      )
    };
    onEulaAccept({
      eula: datedEula,
      context: context,
      optional: optionalEulaAcceptancePayload
    });
  };
  const footerChildren = (
    <Flex gap={3}>
      <Button
        variant="primary"
        className="qa-submit-button"
        flex={1}
        onClick={() => {
          acceptEulaClick();
        }}
      >
        Accept
      </Button>
      <Box w="8px" />
      <Button
        variant="secondary"
        className="qa-cancel-button"
        flex={1}
        onClick={() => {
          onEulaCancel(true);
        }}
      >
        Cancel
      </Button>
    </Flex>
  );

  return (
    <div className={'qa-acceptable-eula acceptable-eula'}>
      <Modal
        footerChildren={footerChildren}
        closable={false}
        title={'CodaMetrix End User License Agreement'}>
        <div>{eula.text}</div>
        {/* <ReactMarkdown children={eula.text}></ReactMarkdown> */}
      </Modal>
    </div>
  );
};

AcceptableEula.displayName = 'AcceptableEula';

export default AcceptableEula;
